module.exports = __webpack_public_path__ + "img/sms.4a087a4d.jpg";